import React, { useEffect, useState } from "react";
import calender from "../../assets/images/icon/calednder-date.svg";
import Select from "react-select";
import { getRangeDateTimeString } from "helpers/common";

import leftarrow from "../../assets/images/left-arrow.svg";
import rightarrow from "../../assets/images/right-arrow.svg";
import { useTranslation } from "react-i18next";
import moment from "moment";

function DashboardTimeline(props) {
  let techInterviews = props?.data?.techInterviews || [];
  let onboardingDetails = props?.data?.onboardingDetails || [];
  let companyValues = props?.data?.companyValues || [];
  let date = props?.agendaDate;
  let setDate = props?.setAgendaDate;
  const [company_id, setCompanyID] = useState("");
  const [filteredTechInterviews, setFilteredTechInterviews] = useState([]);
  const [filteredOnboardingDetails, setFilteredOnboardingDetails] = useState(
    []
  );

  // Initialize filtered data when component mounts or data changes
  useEffect(() => {
    filterAgendaData(moment(date).format("DD-MM-YYYY"));
  }, [techInterviews, onboardingDetails, date]);

  useEffect(() => {
    if (companyValues?.length === 1 && !company_id) {
      setCompanyID(companyValues[0]?.value);
    }
  }, [companyValues]);

  const renderCheck = el => {
    if (companyValues?.length === 1) {
      return true;
    }

    if (el?.applied_job?.company?.id === company_id) {
      return true;
    }
    return false;
  };

  //rohitcode
  const weekArray = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  const monthArray = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const { t } = useTranslation();
  const [currentDate, setCurrentDate] = useState(new Date());
  const [displayMonth, setDisplayMonth] = useState(currentDate.getMonth());
  const [selectedMonth, setSelectedMonth] = useState(currentDate.getMonth());
  const [displayYear, setDisplayYear] = useState(currentDate.getFullYear());
  const [selectedYear, setSelectedYear] = useState(currentDate.getFullYear());
  const [days, setDays] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isCalendarVisible, setIsCalendarVisible] = useState(false);

  useEffect(() => {
    generateCalendarDays(new Date(selectedYear, selectedMonth, 1));
  }, [selectedMonth, selectedYear]);

  useEffect(() => {
    updateTodayButtonText();
  }, [currentDate]);

  const generateCalendarDays = date => {
    const year = date.getFullYear();
    const month = date.getMonth();
    const totalDaysInMonth = getTotalDaysInAMonth(year, month);
    const firstDayOfWeek = getFirstDayOfWeek(year, month);

    const daysArray = [];

    // Add days from the previous month
    const prevMonth = month === 0 ? 11 : month - 1;
    const prevYear = month === 0 ? year - 1 : year;
    const totalDaysInPrevMonth = getTotalDaysInAMonth(prevYear, prevMonth);

    for (let i = firstDayOfWeek - 1; i >= 0; i--) {
      daysArray.push({
        day: totalDaysInPrevMonth - i,
        isCurrentMonth: false,
      });
    }

    // Add days from the current month
    for (let day = 1; day <= totalDaysInMonth; day++) {
      daysArray.push({
        day,
        isCurrentMonth: true,
      });
    }

    setDays(daysArray);
  };

  const getTotalDaysInAMonth = (year, month) => {
    return new Date(year, month + 1, 0).getDate();
  };

  const getFirstDayOfWeek = (year, month) => {
    return new Date(year, month, 1).getDay();
  };

  const handleTodayClick = () => {
    const today = new Date();
    setSelectedMonth(today.getMonth());
    setSelectedYear(today.getFullYear());
    setSelectedDate(today.getDate());
    generateCalendarDays(today);
    updateTodayButtonText();
  };

  const handleMonthChange = event => {
    setSelectedMonth(parseInt(event.target.value));
    setIsCalendarVisible(true); // Show the calendar when a month is selected
    setIsPopupOpen(false); // Optionally close the dropdown if needed
  };

  const handleYearChange = event => {
    setSelectedYear(parseInt(event.target.value));
  };

  const handleLeftArrowClick = () => {
    const newMonth = selectedMonth === 0 ? 11 : selectedMonth - 1;
    const newYear = selectedMonth === 0 ? selectedYear - 1 : selectedYear;
    setSelectedMonth(newMonth);
    setSelectedYear(newYear);
    generateCalendarDays(new Date(newYear, newMonth, 1));
    return { newMonth, newYear };
  };

  const handleRightArrowClick = () => {
    const newMonth = selectedMonth === 11 ? 0 : selectedMonth + 1;
    const newYear = selectedMonth === 11 ? selectedYear + 1 : selectedYear;
    setSelectedMonth(newMonth);
    setSelectedYear(newYear);
    generateCalendarDays(new Date(newYear, newMonth, 1));
  };

  const handleDateClick = dayObject => {
    let newSelectedDate;
    if (!dayObject.isCurrentMonth) {
      const { newMonth, newYear } = handleLeftArrowClick();
      newSelectedDate = new Date(newYear, newMonth, dayObject.day);
    } else {
      newSelectedDate = new Date(selectedYear, selectedMonth, dayObject.day);
    }
    setSelectedDate(dayObject.day);
    setDisplayMonth(newSelectedDate.getMonth());
    setIsPopupOpen(false); // Close the calendar popup when a date is selected
    setDate(moment(newSelectedDate).format("DD-MM-YYYY"));
  };

  const filterAgendaData = selectedDate => {
    const filteredTechInterviews = techInterviews.filter(el =>
      moment(el?.int_start_time).isSame(moment(selectedDate), "day")
    );

    const filteredOnboardingDetails = onboardingDetails.filter(el =>
      moment(el?.board_time).isSame(moment(selectedDate), "day")
    );

    setFilteredTechInterviews(filteredTechInterviews); // Update state for filtered data
    setFilteredOnboardingDetails(filteredOnboardingDetails);
  };

  const togglePopup = () => {
    setIsPopupOpen(prev => !prev);
  };

  const updateTodayButtonText = () => {
    const today = new Date();
    const button = document.querySelector(
      ".calendar-today-button .button-text"
    );
    button.textContent = (
      <>
        <span>{today.getDate()}</span> {monthArray[today.getMonth()]}
        {today.getFullYear()}
      </>
    );
  };

  const today = new Date();
  const todayDateDisplay = (
    <>
      <span>{today.getDate()} </span> {monthArray[today.getMonth()]}
      {today.getFullYear()}
    </>
  );

  const getSelectClassName = () => {
    const selectedMonthName = monthArray[selectedMonth];

    // Add classes based on month content
    if (["January", "February"].includes(selectedMonthName)) {
      return "mid-month";
    } else if (
      ["March", "April", "May", "June", "July", "August"].includes(
        selectedMonthName
      )
    ) {
      return "small-month";
    } else {
      return "large-month";
    }
  };
  // Function to check if selected date is today's date
  const isToday = () => {
    const today = new Date();
    return (
      selectedDate === today.getDate() &&
      selectedMonth === today.getMonth() &&
      selectedYear === today.getFullYear()
    );
  };

  return (
    <>
      <div className="date-timeline-card">
        {/* Render "Today's Activity" text only if the selected date is today or no date is selected */}
        {selectedDate === null || isToday() ? (
          <h5 className="heading-four">{t(`Dashboard.Today's Activity`)}</h5>
        ) : (
          <h5 className="heading-four">{t(`Dashboard.Activity of the Day`)}</h5>
        )}
        <div className="calder-slider">
          <div className="calendar-month-arrow-container">
            <div className="calendar-month-year-container">
              <select
                className="calendar-years"
                value={selectedYear}
                onChange={handleYearChange}
              >
                {Array.from(
                  { length: 121 },
                  (_, i) => currentDate.getFullYear() - 60 + i
                ).map(year => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </select>
            </div>
            <div className="calendar-month-year">
              {monthArray[selectedMonth]} {selectedYear}
            </div>

            <div className="selected-date-display">
              {selectedDate ? (
                <>
                  <span>{selectedDate}</span> {monthArray[displayMonth]}{" "}
                  {displayYear}
                </>
              ) : (
                todayDateDisplay
              )}
            </div>
            <div className="calendar-arrow-container">
              <button
                className="calendar-today-button"
                onClick={handleTodayClick}
              >
                <div className="button-text"></div>
              </button>
              <button
                className="calendar-left-arrow"
                onClick={handleLeftArrowClick}
              >
                <img src={leftarrow} alt="left arrow" />
              </button>

              <div className="calender-months-selct">
                <img src={calender} alt="calendar" className="caldender-imgs" />
                <select
                  className={`calendar-months form-select ${getSelectClassName()}`}
                  value={selectedMonth}
                  onChange={handleMonthChange}
                  onClick={togglePopup} // Toggle calendar popup on click
                >
                  {monthArray.map((month, index) => (
                    <option key={index} value={index}>
                      {month}
                    </option>
                  ))}
                </select>
              </div>
              <button
                className="calendar-right-arrow"
                onClick={handleRightArrowClick}
              >
                <img src={rightarrow} alt="right arrow" />
              </button>
            </div>
          </div>
          {isCalendarVisible && ( // Render the calendar if it's visible
            <div
              className={`calendar-container ${
                isPopupOpen ? "popup-open" : ""
              }`}
            >
              <ul className="calendar-week">
                {weekArray.map((day, index) => (
                  <li key={index} className="calendar-week-day">
                    {day}
                  </li>
                ))}
              </ul>
              <ul className="calendar-days">
                {days.map((dayObj, index) => {
                  const isToday =
                    dayObj.isCurrentMonth &&
                    dayObj.day === new Date().getDate() &&
                    selectedMonth === new Date().getMonth() &&
                    selectedYear === new Date().getFullYear();

                  return (
                    <div
                      key={index}
                      className={`calendar-day cursor-pointer ${
                        dayObj.isCurrentMonth
                          ? "calendar-day-active"
                          : "calendar-day-inactive"
                      } ${isToday ? "calendar-day-today" : ""} ${
                        dayObj.day === selectedDate
                          ? "calendar-day-selected"
                          : ""
                      }`}
                      onClick={() => handleDateClick(dayObj)}
                    >
                      {dayObj.day}
                    </div>
                  );
                })}
              </ul>
            </div>
          )}
        </div>

        {companyValues?.length > 1 && (
          <Select
            className="mb-2"
            placeholder="Select Company"
            id="company_id"
            name="company_id"
            options={companyValues}
            onChange={e => {
              setCompanyID(e.value);
            }}
            value={companyValues?.find(el => el?.value === company_id)}
          />
        )}

        <div className="calender-timeline">
          <div className="calendert-card">
            {filteredTechInterviews?.filter(renderCheck).map(el => (
              <div className="calender-site-card blue" key={el.id}>
                <span>TECHNICAL INTERVIEW</span>
                <h4>{el?.applied_job?.name || ""}</h4>
                <h5>({el?.interview_title})</h5>
                <p>
                  {getRangeDateTimeString(
                    new Date(el?.int_start_time),
                    new Date(el?.int_end_time),
                    el?.master_time_zone?.offset || ""
                  )}{" "}
                  {el?.master_time_zone?.alias || ""}
                </p>
              </div>
            ))}

            {filteredOnboardingDetails.map(el => (
              <div className="calender-site-card green" key={el.id}>
                <span>ONBOARDING</span>
                <h4>{el?.applied_job?.name || ""}</h4>
                <p>{el?.board_time}</p>
              </div>
            ))}

            {/* <div className="date-time-card">
              <ul>
                <li>
                  11h00 <span></span>
                </li>
                <li>
                  12h00 <span></span>
                </li>
                <li>
                  13h00 <span></span>
                </li>
              </ul>
            </div> */}

            {techInterviews?.filter(renderCheck).length === 0 &&
              onboardingDetails?.filter(renderCheck).length === 0 && (
                <div className="no-data data-available">
                  <img
                    src="../img/data-not-available.png"
                    alt="data not available"
                  />
                  <h3>{t(`Dashboard.No Item Found`)}</h3>
                  <p>
                    {t(`Dashboard.Sorry`)}
                    <br /> {t(`Dashboard.Item to show here`)}
                  </p>
                </div>
              )}
          </div>
        </div>
      </div>
    </>
  );
}

export default DashboardTimeline;
